<template>
    <div class="table_wrap">
        <div class="c_table_wrap table_search_wrap">
            <div class="filter-select-div el-filter-date mb20">
                <span class="filter-select-span mr24 mb10">지역</span>
                <el-radio-group v-model="filterArea" @change="setFilterFunc('ac', filterArea)" class="a_r_g_btn">
                    <el-radio :label="``" class="a_r_btn">전체</el-radio>
                    <el-radio :label="area.ac_idx" class="a_r_btn" v-for="area in areaList" :key="`area${area.ac_idx}`">{{area.is_city_name}}</el-radio>
                </el-radio-group>

            </div>
            <br/>
            <div class="filter-select-div el-filter-date mb11">
                <span class="filter-select-span mr24">신청일</span>
                <span class="el-date-icon mr2" :class="checkFilterData() ? 'iconMove' : ''">
                        <span class="el-date-icon-img"></span>
                        <el-date-picker
                                v-model="filterDate"
                                type="daterange"
                                range-separator=""
                                value-format="yyyy-MM-dd"
                                start-placeholder="시작날짜"
                                end-placeholder="끝 날짜"
                                @change="setFilterFunc('sub',filterDate)"
                                class="el-date-common"
                                prefix-icon=" "
                                clear-icon="el-icon-circle-close el-clear-icon"
                        ></el-date-picker>
                    </span>
            </div>
            <br/>
            <div class="filter-select-div el-filter-date ">
                <span class="filter-select-span mr24">이름</span>
                <el-input
                        class="table_s_input search-input mr5"
                        v-model="searchInput"
                        size=""
                        placeholder="검색어를 입력해주세요."
                        maxLength="40"
                        @keyup.enter.native="setFilterFunc('na', searchInput)"
                >
                </el-input>
                <el-button class="search-button" @click="setFilterFunc('na', searchInput)">
                    검색
                </el-button>
            </div>

            <div class="filter-show-count">
                <el-select v-model="size" @change="changePage('size', size)" >
                    <el-option v-for="(sizeData) in sizeList" :key="`size${sizeData}`" :value="sizeData" :label="`${sizeData}개씩 보기`"></el-option>
                </el-select>
            </div>
        </div>
    </div>
</template>

<script>
    import memberUtil from "@/components/member/memberUtil";
    import util from "@/mixins/util";
    const {filterConfig} = memberUtil;
    export default {
        name: "MemberFilterWaitLayout",
        mixins: [],
        components: {},
        inject:['setPage','setFilter'],
        provide() {
            return {}
        },
        props: {
            filterData: {default: () => {return {}}},
            paginationData: {default: () => { return { total: 0, page: 0, size: 0, }}},
            areaList:{
                type: Array,
                default: () => {return []}
            },
        },
        data() {
            return {
                searchInput: '',
                filterUse: '',
                filterDate: [],
                filterArea:'',

                size: 10,
                sizeList: [10, 30, 50],
            }
        },
        created() {},
        mounted() {
            this.setterFilterDataInData();

        },
        beforeDestroy() {},
        destroyed() {},
        computed: {
        },
        methods: {
            setterFilterDataInData() {
                let classnames = Object.keys(this.filterData);
                classnames.forEach(classname => {
                    let obj = this.filterData[classname];
                    let type = filterConfig[obj.key].type;
                    if(this.hasOwnProperty(classname)) {
                        // this[classname] =
                        if(type == 'query') {
                            this[classname] = obj.query;
                        }else if(type === 'between') {
                            this[classname] = [obj.start, obj.end];
                        }else if(type === 'match') {
                            if(isNaN(obj.value)) {
                                this[classname] = obj.value;
                            }else{
                                this[classname] = Number(obj.value);
                            }

                        }

                    }
                })
                this.size = this.paginationData.size;
            },
            setFilterFunc(key, value) {
                this.setFilter(key, value);
            },

            changePage(key, value) {
                this.setPage(key, value);
                this.setPage('page',1);
            },
            checkFilterData(){
                return this.filterDate != null&&this.filterDate.length > 0;
            },


        },
        watch: {},
    }
</script>

<style lang="scss">
    .a_r_g_btn{
        width: calc(100% - 110px);
    }
    .a_r_btn{
        margin-bottom: 10px;
    }

</style>